import React, { Component, Fragment } from "react";
import { injectIntl } from "react-intl";
import { DatePicker, RangeDatePicker } from "jalali-react-datepicker";
import API from "../../../api/index";
var classNames = require("classnames");
import ReactTimeAgo from "react-time-ago";
import { NotificationManager } from "Components/ReactNotifications";
import moment from "jalali-moment";

import { logoutUser } from "Redux/actions";
import { connect } from "react-redux";
import CustomSelectInput from "Components/CustomSelectInput";
import Select from "react-select";
import { Row, Card, CardBody, CardTitle, Button, Collapse, FormGroup, Label, Input, Form, timeoutsShape } from "reactstrap";
import StateButton from "Components/StateButton";

import NumberFormat from "react-number-format";
import { Colxx, Separator } from "Components/CustomBootstrap";

class archive extends Component {
	constructor(props) {
		super(props);

		this.state = {
			lead: {},
			toggleSMSClicked: false,
			isLoading: true,
		};

		this.loadData = this.loadData.bind(this);
		this.toggleSMS = this.toggleSMS.bind(this);
	}
	toggleSMS() {
		return new Promise((success, fail, $this) => {
			this.setState({ toggleSMSClicked: true });

			API.sms
				.toggleBanned({
					NodeID: this.state.lead.leadID,
				})
				.then((data) => {
					data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;

					if (data.ERRORS !== undefined) {
						fail("خطا در تغییر وضعیت دریافت پیامک ");
						for (var i = 0; i < data.ERRORS.length; i++) {
							setTimeout(
								function (err) {
									NotificationManager.error(err, "خطا در ویرایش وضعیت دریافت پیامک ", 8000, null, null, "filled");
								},
								(i + 1) * 700,
								data.ERRORS[i]
							);
							this.setState({
								toggleSMSClicked: false,
							});
						}
					} else {
						success("تغییر وضعیت ثبت شد");
						setTimeout(() => {
							this.setState(
								{
									toggleSMSClicked: false,
								},
								() => {
									this.loadData();
								}
							);
						}, 1000);
					}
				})
				.catch((error) => {
					fail("خطا در تغییر وضعیت دریافت پیامک ");
				});
		});
	}
	componentDidMount() {
		this.loadData();
	}

	loadData() {
		API.crm.lead
			.view({ LeadMobile: this.props.match.params.leadMobile })
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;

				if (data.ERRORS !== undefined) {
					for (var i = 0; i < data.ERRORS.length; i++) {
						setTimeout(
							function (err) {
								NotificationManager.error(err, "سرنخ پیدا نشد", 8000, null, null, "filled");
							},
							(i + 1) * 700,
							data.ERRORS[i]
						);
						this.setState({
							isLoading: true,
						});
					}
				} else {
					this.setState({
						lead: data.lead,
						isLoading: false,
					});
				}
			})
			.catch((error) => {});
	}
	render() {
		return this.state.isLoading ? (
			<div className="loading"></div>
		) : (
			<Fragment>
				<Row className="mb-4 searchdropdown">
					<Colxx xxs="2"></Colxx>
					<Colxx xxs="8">
						<Card>
							<CardBody>
								<CardTitle>
									<div
										onClick={(e) => {
											this.props.history.push("/app/crm/lead/");
										}}
										className="breadcrumb-item"
									>
										<div className={"iconsminds-leaning-tower headingicon"} /> سرنخ ها
									</div>
									<span className="breadcrumb-arrow" style={{ marginLeft: "10px" }}>
										{" > "}
									</span>
									<div className={"simple-icon-info headingicon"} />
									اطلاعات سرنخ
								</CardTitle>
								<span className={"cardtitleicons biginfo"}>
									<i className={"simple-icon-screen-smartphone"}></i>
									{this.state.lead.Mobile}
								</span>{" "}
								<span className={"cardtitleicons biginfo"}>
									<i className={"iconsminds-stopwatch"}></i>
									ایجاد : {moment(this.state.lead.CreatedAt).locale("fa").format("DD / MMMM / YYYY - HH:mm")}
								</span>{" "}
								<span className={"cardtitleicons biginfo"}>
									<i className={"iconsminds-consulting"}></i>
									{this.state.lead.OperatorName}
								</span>{" "}
								<span className={"cardtitleicons biginfo"}>
									<i className={"iconsminds-pulse"}></i>
									{this.state.lead.Pulses.length}
								</span>{" "}
								
								{this.state.lead.Converted ? (
									<span>
										<br />
										<span className={"cardtitleicons biginfo"} style={{ backgroundColor: "#ecfdff", border: "2px solid #56cfc6", color: "#56cfc6" }}>
											<i className={"simple-icon-check"}></i>
											تبدیل شده
										</span>
										<span className={"cardtitleicons biginfo"}>
											<i className={"iconsminds-stopwatch"}></i>
											تبدیل : {moment(this.state.lead.CreatedAt).locale("fa").format("DD / MMMM / YYYY - HH:mm")}
										</span>
										<span className={"cardtitleicons biginfo"}>
											<i className={"iconsminds-business-man-woman"}></i>
											<a href={"/app/customers/view-customer/" + this.state.lead.Mobile} target="_blank">
												{this.state.lead.Mobile}
											</a>
										</span>
									</span>
								) : (
									<span className={"cardtitleicons biginfo"}>
										<i className={"iconsminds-leaning-tower"}></i>
										سرنخ
									</span>
								)}{localStorage.getItem("user_can").split(",").indexOf("manage-sms") != -1 ? (
									<Button
										onClick={() => {
											window.open("https://smp.akschap.com/report-mobile/" + this.state.lead.Mobile);
										}}
										disabled={false}
										id="toggleSMS"
										className="default mb-2"
										style={{ position: "relative", marginLeft:"10px",marginTop:"5px",borderRadius:"5px",padding:"15px",color: "#60707c" }}
										color="secondary"
									>
										همه پیامک ها
									</Button>
								) : (
									false
								)}{" "}
								{localStorage.getItem("user_can").split(",").indexOf("manage-sms") == -1 ? (
									<span className={"cardtitleicons biginfo"} style={{ color: this.state.lead.smsBanned ? "darkorange" : "#56cfc6" }}>
										<i
											style={{ fontSize: "16px", marginLeft: "10px" }}
											className={classNames({
												"iconsminds-mail-block": this.state.lead.smsBanned,
												"iconsminds-mail-inbox": !this.state.lead.smsBanned,
											})}
										></i>
										{classNames({
											"پیامک مسدود": this.state.lead.smsBanned,
											"پیامک فعال": !this.state.lead.smsBanned,
										})}
									</span>
								) : (
									<StateButton
										id="toggleSMS"
										color="light"
										className={classNames({
											default: true,
											"mb-2": true,
											"outline-dark-btn": true,
											"sms-toggle-button": true,
											"sms-toggle-button-active": !this.state.lead.smsBanned,
											"sms-toggle-button-blocked": this.state.lead.smsBanned,
										})}
										onClick={() => this.toggleSMS()}
									>
										<i
											style={{ fontSize: "16px", marginLeft: "10px" }}
											className={classNames({
												"iconsminds-mail-block": this.state.lead.smsBanned,
												"iconsminds-mail-inbox": !this.state.lead.smsBanned,
											})}
										></i>
										{classNames({
											"پیامک مسدود": this.state.lead.smsBanned,
											"پیامک فعال": !this.state.lead.smsBanned,
										})}
									</StateButton>
								)}{" "}
								
							</CardBody>
						</Card>
						<br />
						<Card>
							<CardBody>
								<CardTitle>
									<div className={"iconsminds-pulse headingicon"} />
									پالس ها
								</CardTitle>

								<Fragment>
									<br />
								</Fragment>
								{!this.state.isRefreshing ? (
									<div className="table-responsive">
										<table className="table table-hover order-table">
											<thead>
												<tr>
													<th>کد پالس</th>
													<th>زمان ثبت</th>
													<th>پالس</th>
													<th>اپراتور</th>
												</tr>
											</thead>

											{this.state.lead.Pulses.map((row) => (
												<TableBodyRows key={row.PulseID} data={row} />
											))}
										</table>
									</div>
								) : (
									<div className="loading" style={{ left: "unset", top: "unset", position: "relative", display: "block", marginLeft: "auto", marginRight: "auto" }}></div>
								)}
							</CardBody>
						</Card>
					</Colxx>
				</Row>
			</Fragment>
		);
	}
}

class TableBodyRows extends Component {
	render() {
		const {
			data: { PulseID, CreatedAt, PulseTagName, OperatorName },
		} = this.props;
		return (
			<tbody>
				<tr className={"order-spacer"}></tr>
				<tr className={"order-item"}>
					<td className={"text-muted"}>{PulseID}</td>
					<td className={"text-muted"}>{moment(CreatedAt).locale("fa").format("DD / MMMM / YYYY - HH:mm")}</td>

					<td className={"text-muted"}>
						<ul className={"pulses"}>
							<li>{PulseTagName} </li>
						</ul>
					</td>
					<td className={"text-muted"}>{OperatorName}</td>
				</tr>
			</tbody>
		);
	}
}

const mapStateToProps = ({ menu, settings }) => {
	return { logoutUser };
};
export default injectIntl(connect(mapStateToProps, { logoutUser })(archive));
// export default injectIntl(archive);
